import React from 'react';
import PropTypes from 'prop-types';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import Empty from 'constants/empty';
import Modal from 'components/Modal/Modal';
import { space, mediaQueries } from 'style/config';
import CreateNewListModal from 'components/CreateNewList';
import { LOVES_LIST_MAX, OTHER_LIST_MAX } from 'constants/sharableList';
import ViewAllLovesBindings from 'analytics/bindingMethods/pages/viewAllLovesBindings/ViewAllLovesBindings';
import ProductImage from 'components/Product/ProductImage/ProductImage';
import {
    Button, Flex, Box, Text, Grid, Icon, Link
} from 'components/ui';
import anaConsts from 'analytics/constants.js';
import store from 'store/Store';
import LoveActions from 'actions/LoveActions';
import Location from 'utils/Location';
import myListsUtils from 'utils/MyLists';
import myListsBindings from 'analytics/bindingMethods/components/globalModals/myLists/myListsBindings';
import {
    MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT,
    MAX_LIMITED_LOVE_ITEMS_MY_LISTS_HOME_PAGE,
    MAX_FLYOUT_RECENT_ITEMS,
    RECENT_ITEMS_PAGINATION_SIZE,
    MIN_ITEMS_PER_PAGE,
    GENERIC_FETCHING_ERROR
} from 'constants/sharableList';
import { PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT } from 'ai/constants/superchat';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const { USER_PROFILE } = anaConsts.PAGE_TYPES;
const { LOVES } = anaConsts.EVENT_NAMES;
class MyListsModal extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            skus: props.skuList,
            title: props.title,
            targetUrl: props.action?.targetUrl,
            isCreateNewListModal: false,
            listNameTextMessage: '',
            listNameTextError: false,
            isHidden: true,
            listErrorsById: {},
            ctaClickedById: {},
            hasClickedCtaOnceById: {},
            shouldDisplayImageById: {},
            isInListById: {},
            isDefaultListAdd: false,
            newListCreated: false,
            itemsCount: this.deriveCounts(props.myLists) || {},
            isLovesEventTriggered: false, //STAG analytics event purpose,
            apiCallInProgress: false,
            shouldCallLimitedItems: false,
            invalidateRecentItemsCache: false
        };
    }

    deriveCounts = myLists => {
        return (
            myLists?.allLoves?.reduce((acc, list) => {
                acc[list.shoppingListId] = list.shoppingListItemsCount;

                return acc;
            }, {}) || {}
        );
    };

    toogleCreateNewListModal = () => {
        //Trigger STAG Analytics event
        if (!this.state?.isCreateNewListModal) {
            ViewAllLovesBindings.triggerSOTLinkTrackingAnalytics({
                eventName: anaConsts.EVENT_NAMES.LOVES.CREATE_NEW_LIST
            });
        }

        this.setState(prevState => ({
            isCreateNewListModal: !prevState.isCreateNewListModal
        }));
    };

    handleLoveError = (error, listId) => {
        const localization = this.props.localization || Empty.Object;
        const { somethingWentWrong } = localization;

        if (!error) {
            return;
        }

        const msg = (error?.message && !error.message.includes(GENERIC_FETCHING_ERROR)) || error?.response?.data?.error || somethingWentWrong;
        myListsBindings.triggerErrorAnalytics({ errorMessage: msg });
        this.setState(prev => ({
            listErrorsById: {
                ...prev.listErrorsById,
                [listId]: msg
            },
            isInListById: {
                ...prev.isInListById,
                [listId]: false
            },
            apiCallInProgress: false
        }));
    };

    getShoppingListItems = (data, shoppingListId) => {
        const list = data?.allLoves?.find(({ shoppingListId: id }) => id === shoppingListId);

        if (!list?.shoppingListItems?.length) {
            return { skuIdString: '', shoppingListItemsCount: 0 };
        }

        const skuIdString = list.shoppingListItems.flatMap(item => (item.sku?.skuId ? [item.sku.skuId] : [])).join(',');

        return {
            skuIdString,
            shoppingListItemsCount: list.shoppingListItemsCount ?? list.shoppingListItems.length
        };
    };

    //check trgetSkuId available in the loves List
    checkSkuAvailableInList = (loves, targetSkuId) => {
        let isAvailable = false;

        // Iterate through each shopping list in allLoves
        for (const list of loves) {
            // Iterate through each item in shoppingListItems
            for (const item of list.shoppingListItems) {
                // Check if sku exists and add skuId to Set
                if (item.sku && item.sku.skuId) {
                    // Check if skuId matches targetSkuId
                    if (item.sku.skuId === targetSkuId) {
                        isAvailable = true;
                    }
                }
            }
        }

        return isAvailable;
    };

    addToList = (skuLoveData, listId = null, shoppingListName = null) => {
        const {
            addItemToSharableList, myLists = Empty.Object, myCustomList, updateCustomList, currentProduct, currentLovesSkuDetails
        } = this.props;
        const customListToUpdate = myCustomList.shoppingListId === listId && { ...myCustomList };
        const productInFlatListInRedux = myListsUtils.findMatchingSku(currentLovesSkuDetails, skuLoveData.skuId, skuLoveData.productId);
        const payload = {
            source: 'productPage',
            productId: skuLoveData.productId,
            skuId: skuLoveData.skuId
        };
        const skuId = skuLoveData.skuId;
        const lovesLists = myLists?.allLoves?.filter(list => !list.isCreateList) || [];

        const list = listId ? myLists.allLoves.find(l => l.shoppingListId === listId) : undefined;

        if (listId) {
            payload.shoppingListId = listId;
            payload.shoppingListName = shoppingListName;
        }

        const { skuIdString, shoppingListItemsCount } = this.getShoppingListItems(myLists, listId);

        const analyticsData = {
            skuIdString: skuIdString || '',
            shoppingListItemsCount: shoppingListItemsCount || null
        };

        return addItemToSharableList(
            payload,
            response => {
                // Update the flat list by adding the listName to the corresponding sku item
                // or adding a new sku item if it does not exist
                const flatListToUpdate = currentLovesSkuDetails.map(item => {
                    if (item.sku.skuId === skuLoveData.skuId && item.sku.productId === skuLoveData.productId) {
                        const newListNames = [...item.listNames, shoppingListName];

                        return {
                            ...item,
                            listNames: newListNames,
                            listShortName: newListNames.join(',')
                        };
                    }

                    return item;
                });
                this.setState({ invalidateRecentItemsCache: true });

                if (!productInFlatListInRedux) {
                    flatListToUpdate.unshift({
                        listNames: [shoppingListName],
                        listShortName: shoppingListName,
                        sku: {
                            ...currentProduct,
                            productId: skuLoveData.productId
                        }
                    });
                }

                this.props.updateLovesListSkuDetails({ loves: flatListToUpdate });

                // Update the custom list in the redux store if the removed item belongs to it
                // so if user goes to the custom list page, they land into previous scroll position with updated data
                if (customListToUpdate && currentProduct) {
                    customListToUpdate.shoppingListItems.unshift({
                        shoppingListItemId: response.shoppingListItemId,
                        sku: {
                            ...(currentProduct.currentSku || currentProduct),
                            productId: skuLoveData.productId
                        }
                    });
                    customListToUpdate.shoppingListItemsCount = customListToUpdate.shoppingListItemsCount + 1;
                    updateCustomList(customListToUpdate);
                }

                if (list && !list.isDefault) {
                    myListsBindings.addToList({ skuId });
                } else if (myLists?.allLoves && lovesLists.length > 1) {
                    myListsBindings.addToLove({ skuId });
                }

                this.setState(prev => ({
                    isInListById: {
                        ...prev.isInListById,
                        [listId]: true
                    },
                    imageDisplayFlag: {
                        ...prev.imageDisplayFlag,
                        [listId]: true
                    },
                    itemsCount: {
                        ...prev.itemsCount,
                        [listId]: prev.itemsCount[listId] + 1
                    },
                    ctaClickedById: {
                        ...prev.ctaClickedById,
                        [listId]: false
                    },
                    shouldDisplayImageById: {
                        ...prev.shouldDisplayImageById,
                        [listId]: true
                    },
                    listErrorsById: {
                        ...prev.listErrorsById,
                        [listId]: null
                    },
                    apiCallInProgress: false,
                    shouldCallLimitedItems: skuLoveData.isOnlyFewLeft
                }));

                this.updateLovedItems({ skuId: skuId, productId: skuLoveData.productId, listName: shoppingListName, action: 'add' });

                // Add to Loves Analytics
                // Build productString using the same method as addToLove to ensure productStrings is included for Bluecore
                const productStrings = myListsBindings.buildProductString({ skuId });
                const trackingData = {
                    eventName: anaConsts.EVENT_NAMES.LOVES.ADD_TO_LOVES,
                    productStrings: productStrings,
                    ...analyticsData,
                    ...(response || {})
                };

                ViewAllLovesBindings.triggerSOTLinkTrackingAnalytics(trackingData);
                ViewAllLovesBindings.triggerAnalytics(trackingData);
            },
            error => {
                this.handleLoveError(error, listId);
            }
        );
    };

    handleToggleLove = (skuLoveData, listId) => {
        const {
            myLists = Empty.Object, myCustomList, localization = Empty.Object, removeItemFromSharableList, updateCustomList, currentLovesSkuDetails
        } = this.props;
        const { itemsCount, apiCallInProgress } = this.state;
        const list = myLists.allLoves.find(l => l.shoppingListId === listId);

        if (!list || apiCallInProgress) {
            return;
        }

        const skuId = skuLoveData.skuId;
        const productId = skuLoveData.productId;
        const hasStateEntry = Object.prototype.hasOwnProperty.call(this.state.isInListById, listId);
        const isSkuInList = hasStateEntry
            ? this.state.isInListById[listId]
            : list.shoppingListItems.some(item => item.sku.skuId === skuId && item.sku.productId === productId);

        this.setState(prev => ({
            hasClickedCtaOnceById: {
                ...prev.hasClickedCtaOnceById,
                [listId]: true
            },
            ctaClickedById: {
                ...prev.ctaClickedById,
                [listId]: true
            },
            listErrorsById: {
                ...prev.listErrorsById,
                [listId]: null
            },
            apiCallInProgress: true
        }));
        const customListToUpdate = myCustomList.shoppingListId === listId && { ...myCustomList };
        const productInFlatListInRedux = myListsUtils.findMatchingSku(currentLovesSkuDetails, skuLoveData.skuId, skuLoveData.productId);

        if (isSkuInList) {
            const productLoveData = {
                skuId: skuLoveData.skuId,
                productId: skuLoveData.productId,
                type: 'loves',
                id: listId
            };
            removeItemFromSharableList(
                productLoveData,
                response => {
                    const flatListToUpdate = currentLovesSkuDetails
                        .map(item => {
                            if (item.sku.skuId !== skuLoveData.skuId || item.sku.productId !== skuLoveData.productId) {
                                return item;
                            }

                            if (item.listNames.length === 1) {
                                return null; // tag to remove it when filtering
                            }

                            const newListNames = item.listNames.filter(name => name !== list.shoppingListName);

                            return {
                                ...item,
                                listNames: newListNames,
                                listShortName: newListNames.join(',')
                            };
                        })
                        .filter(Boolean); // removes null item

                    if (customListToUpdate) {
                        // Update the custom list in the redux store if the removed item belongs to it
                        // so if user goes to the custom list page, they land into previous scroll position with updated data
                        customListToUpdate.shoppingListItems = customListToUpdate.shoppingListItems.filter(
                            item => !(item.sku.skuId === skuId && item.sku.productId === productId)
                        );
                        customListToUpdate.shoppingListItemsCount = customListToUpdate.shoppingListItemsCount - 1;
                        updateCustomList(customListToUpdate);
                    }

                    if (productInFlatListInRedux) {
                        this.setState({ invalidateRecentItemsCache: true });
                    }

                    this.props.updateLovesListSkuDetails({
                        loves: flatListToUpdate,
                        totalLovesListItemsCount: flatListToUpdate.length
                    });

                    // Remove from List Analytics
                    // Build productString using the same method as addToList to ensure productStrings is included for Bluecore
                    const productStrings = myListsBindings.buildProductString({ skuId });
                    const { skuIdString, shoppingListItemsCount } = this.getShoppingListItems(myLists, listId);
                    const analyticsData = {
                        skuIdString: skuIdString || '',
                        shoppingListItemsCount: shoppingListItemsCount || null
                    };

                    const eventName = anaConsts.EVENT_NAMES.REMOVE_FROM_LOVES;

                    const trackingData = {
                        eventName,
                        productStrings: productStrings,
                        ...analyticsData,
                        ...(response || {})
                    };

                    const eventPayload = {
                        linkName: eventName,
                        actionInfo: eventName,
                        specificEventName: eventName
                    };

                    if (list.isDefault) {
                        myListsBindings.removeFromLove({ skuId, eventPayload });
                    } else {
                        myListsBindings.removeFromList({ skuId, eventPayload });
                    }

                    this.updateLovedItems({ skuId: skuId, productId: skuLoveData.productId, listName: list.shoppingListName, action: 'remove' });

                    ViewAllLovesBindings.triggerSOTLinkTrackingAnalytics(trackingData);

                    this.setState(prev => ({
                        isInListById: {
                            ...prev.isInListById,
                            [listId]: false
                        },
                        itemsCount: {
                            ...prev.itemsCount,
                            [listId]: prev.itemsCount[listId] - 1 || 0
                        },
                        shouldDisplayImageById: {
                            ...prev.shouldDisplayImageById,
                            [listId]: false
                        },
                        ctaClickedById: {
                            ...prev.ctaClickedById,
                            [listId]: false
                        },
                        listErrorsById: {
                            ...prev.listErrorsById,
                            [listId]: null
                        },
                        apiCallInProgress: false,
                        shouldCallLimitedItems: skuLoveData.isOnlyFewLeft
                    }));
                },
                error => {
                    this.handleLoveError(error, listId);
                },
                skuLoveData.productId
            );
        } else {
            const isLovesListMaxedOut = itemsCount[list.shoppingListId] >= LOVES_LIST_MAX && list.isDefault === true;
            const isOtherListMaxedOut = itemsCount[list.shoppingListId] >= OTHER_LIST_MAX && list.isDefault === false;

            if (isLovesListMaxedOut || isOtherListMaxedOut) {
                const maxErrorMessage = localization.maxProductsSavedErrorMessage;

                myListsBindings.triggerErrorAnalytics({ errorMessage: maxErrorMessage });
                this.setState(prev => ({
                    ctaClickedById: {
                        ...prev.ctaClickedById,
                        [listId]: true
                    },
                    listErrorsById: {
                        ...prev.listErrorsById,
                        [listId]: maxErrorMessage
                    },
                    apiCallInProgress: false
                }));

                return;
            }

            this.addToList(skuLoveData, listId, list.shoppingListName);
        }
    };

    renderCTA = (skuLoveData, listId) => {
        const { myLists = Empty.Object, localization = Empty.Object } = this.props;
        const list = myLists.allLoves.find(l => l.shoppingListId === listId);

        if (!list) {
            return null;
        }

        const skuId = skuLoveData.skuId;
        const productId = skuLoveData.productId;
        const hasStateEntry = Object.prototype.hasOwnProperty.call(this.state.isInListById, listId);
        const isSkuInList = hasStateEntry
            ? this.state.isInListById[listId]
            : list.shoppingListItems.some(item => item.sku.skuId === skuId && item.sku.productId === productId);

        return (
            <Button
                variant='secondary'
                size='sm'
                css={{ alignSelf: 'center' }}
                onClick={() => this.handleToggleLove(skuLoveData, listId)}
                paddingY={0}
            >
                {!isSkuInList ? (
                    localization.add
                ) : (
                    <span>
                        <Icon
                            name='checkmark'
                            size='1em'
                            css={{
                                position: 'absolute',
                                transform: 'translateX(calc(-100% - 18px))'
                            }}
                            marginTop='1px'
                        />
                        <Text
                            fontSize='sm'
                            fontWeight='700'
                            display='block'
                            marginLeft={2}
                        >
                            {localization.added}
                        </Text>
                        <Text
                            fontSize='xs'
                            fontWeight='normal'
                            display='block'
                            color='blue'
                            marginLeft={2}
                        >
                            {localization.remove}
                        </Text>
                    </span>
                )}
            </Button>
        );
    };

    componentDidMount() {
        const { myLists = Empty.Object, showCreateListModal } = this.props;

        if (this.props.user?.beautyInsiderAccount?.biAccountId) {
            this.props.getAllListsSkusOverview({
                callback: () => {
                    store.dispatch(LoveActions.setLoveListUpdated(false));
                },
                force: false,
                options: {
                    skipProductDetails: true
                }
            });
        }

        if (this.props.showCreateListModal) {
            this.toogleCreateNewListModal();
        } else {
            myListsBindings.pageLoadMyListModal({
                pageType: USER_PROFILE,
                eventName: LOVES.MY_LISTS_MODAL
            });
        }

        //STAG analytics
        if (myLists?.allLoves?.length && !showCreateListModal) {
            const data = ViewAllLovesBindings.formatShareableLists(myLists?.allLoves);
            ViewAllLovesBindings.triggerSOTLinkTrackingAnalytics({
                eventName: anaConsts.EVENT_NAMES.LOVES.SHAREABLE_LIST_DISPLAYED,
                ...data,
                listsCount: myLists?.allLoves.length
            });
        }

        // IMPORTANT: This code is required by other stories/features—do not remove.
        // Retrieve data from IndexedDB and save it to component state
        // this.loadLoves();
    }

    // IMPORTANT: This code is required by other stories/features—do not remove.
    // Retrieve data from IndexedDB and save it to component state
    // Ensure to import Storage and initialize component’s state with `loves: {}`
    // loadLoves = async () => {
    //     console.log(' → _loadLoves start');
    //     const cacheKey = 'lovedItemsFlatListSkuOnly';

    //     try {
    //         const cached = await Storage.db.getItem(cacheKey);
    //         console.log(' → after getItem():', cached);

    //         if (cached) {
    //             console.log(' ✔ cache hit, rendering from IndexedDB', cached);
    //             this.setState({ loves: cached, loading: false });
    //         } else {
    //             console.log(' ⚠ no cache—fetching from API');
    //         }
    //     } catch (err) {
    //         console.error(' ✖ error in _loadLoves():', err);
    //         this.setState({ error: err, loading: false });
    //     }
    // };

    componentDidUpdate(prevProps) {
        const { myLists = Empty.Object, skuLoveData, showCreateListModal } = this.props;

        if (myLists?.allLoves !== prevProps.myLists?.allLoves) {
            this.setState({ isHidden: false });
            this.setState({ itemsCount: this.deriveCounts(this.props.myLists) });
        }

        if (myLists?.allLoves !== prevProps.myLists?.allLoves && !this.state.isDefaultListAdd) {
            const loves = myLists?.allLoves?.filter(list => !list.isCreateList) || [];
            const skuId = skuLoveData.skuId;

            //STAG Analytics add to loves event purpose
            const skuAvailable = this.checkSkuAvailableInList(loves, skuId);
            this.setState({ isLovesEventTriggered: skuAvailable });

            if (loves.length === 1) {
                const items = loves[0].shoppingListItems || [];
                const alreadyInList = items.some(item => item.sku.skuId === skuId);

                if (alreadyInList) {
                    this.setState({ isDefaultListAdd: true });

                    return;
                }
            }

            if (myLists?.allLoves && loves.length <= 1 && !showCreateListModal) {
                const defaultList = loves[0] || {};
                const listId = defaultList.shoppingListId;
                const listName = defaultList.shoppingListName;
                myListsBindings.addToLove({ skuId: skuLoveData.skuId });

                this.setState({ isDefaultListAdd: true }, () => {
                    this.addToList(skuLoveData, listId, listName);
                });
            }
        }
    }

    handleNewListCreated = () => {
        this.setState({ newListCreated: true });

        this.props.getAllListsSkusOverview({
            callback: () => {
                store.dispatch(LoveActions.setLoveListUpdated(false));
            },
            force: true,
            options: {
                skipProductDetails: true
            }
        });
    };

    async updateLovedItems({
        key = LOCAL_STORAGE.LOVED_ITEMS_SKU_ONLY, skuId, productId, listName, action
    }) {
        const { modifyLovedItem, updateReduxLoveList } = this.props;
        try {
            modifyLovedItem({
                key,
                skuId,
                productId,
                listName,
                action
            });
            updateReduxLoveList();
        } catch (err) {
            Sephora.logger.error('UpdateCache failed:', err);
        }
    }

    updateItemsData = () => {
        const { getFlatLoveListSkusWithDetails, getAllLists, user, getLimitedLoveListItems } = this.props;
        const { ctaClickedById, newListCreated, shouldCallLimitedItems } = this.state;
        const hasListModifications = Object.keys(ctaClickedById).length > 0 || newListCreated;
        const isMyListsPage = Location.isMyListsPage();

        if (hasListModifications) {
            if (user?.beautyInsiderAccount?.biAccountId) {
                getAllLists({
                    force: true,
                    options: { itemsPerPage: MIN_ITEMS_PER_PAGE },
                    callback: async () => {
                        await Storage.db.removeItem(LOCAL_STORAGE.ALL_LOVE_LIST_SKU_ONLY);
                    }
                });
            }

            getLimitedLoveListItems({
                refreshCache: shouldCallLimitedItems,
                options: {
                    itemsPerPage: isMyListsPage ? MAX_LIMITED_LOVE_ITEMS_MY_LISTS_HOME_PAGE : MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT
                }
            });
            getFlatLoveListSkusWithDetails(
                response => {
                    this.handleStagLovesAnalaytics(response);
                },
                !this.state.invalidateRecentItemsCache,
                {
                    itemsPerPage: isMyListsPage ? RECENT_ITEMS_PAGINATION_SIZE : MAX_FLYOUT_RECENT_ITEMS,
                    currentPage: 1
                }
            );
        }
    };

    handleListClick = (e, targetUrl) => {
        e.preventDefault();
        const {
            showMyListsModal = Empty.Function, setSkuLoveData, showQuickLookModal, getShoppingListById, updateReduxLoveList
        } = this.props;
        const { ctaClickedById, newListCreated } = this.state;
        const hasListModifications = Object.keys(ctaClickedById).length > 0 || newListCreated;
        updateReduxLoveList();

        if (hasListModifications && Location.isMyCustomListPage()) {
            getShoppingListById();
        }

        showMyListsModal(false);
        showQuickLookModal({ isOpen: false });
        setSkuLoveData({
            loveSource: null,
            skuId: null,
            productId: null
        });

        this.updateItemsData();

        if (targetUrl) {
            Location.navigateTo(e, `/profile/Lists/${targetUrl}`);
        }
    };

    handleStagLovesAnalaytics = response => {
        const { skuLoveData, myLists = Empty.Object } = this.props;
        const skuId = skuLoveData?.skuId;

        if (!skuId) {
            return;
        }

        let skuInfo = null;
        const skuIds = response
            .map(list => {
                const currentSkuId = list?.sku?.skuId;

                if (currentSkuId === skuId) {
                    skuInfo = list?.sku;
                }

                return currentSkuId;
            })
            .filter(Boolean);

        const eventAlreadyTriggered = this.state?.isLovesEventTriggered;

        if (skuInfo && !eventAlreadyTriggered) {
            ViewAllLovesBindings.triggerShareableListSOTAnalytics('love', skuId, skuInfo, skuIds);
        } else if (!skuInfo) {
            // Find skuInfo from myLists
            myLists?.allLoves.forEach(list => {
                list.shoppingListItems.forEach(item => {
                    if (item.sku && item.sku.skuId === skuId) {
                        skuInfo = item.sku;
                    }
                });
            });

            // If skuId is not in the list, trigger un-love event
            // Skip if already triggered by SuperChat (loveSource === 'productRecommendation')
            const shouldSkipDuplicateAnalytics = skuLoveData?.loveSource === PRODUCT_RECOMMENDATION_ANALYTICS_CONTEXT;

            if (!skuIds.includes(skuId) && !shouldSkipDuplicateAnalytics) {
                ViewAllLovesBindings.triggerShareableListSOTAnalytics('un-love', skuId, skuInfo, skuIds);
            }
        }
    };

    handleClick = () => {
        const { showMyListsModal = Empty.Function, setSkuLoveData, updateReduxLoveList } = this.props;
        const { ctaClickedById, newListCreated } = this.state;
        const hasListModifications = Object.keys(ctaClickedById).length > 0 || newListCreated;
        updateReduxLoveList();
        this.setState({ newListCreated: false, invalidateRecentItemsCache: true });
        this.updateItemsData();

        if (!hasListModifications) {
            myListsBindings.cancelFlowListsModal();
        }

        showMyListsModal(false);
        setSkuLoveData({
            loveSource: null,
            skuId: null,
            productId: null
        });
    };

    render() {
        const {
            isOpen = false, localization = Empty.Object,
            myLists = Empty.Object,
            showMyListsModal = Empty.Function,
            skuLoveData, skuLoveListImageData,
            isListLimitReached, imageDisplayFlag
        } =
            this.props;
        const {
            isCreateNewListModal, isHidden, listErrorsById, shouldDisplayImageById, hasClickedCtaOnceById, itemsCount
        } = this.state;
        const { title, done, createNewList } = localization;
        const modalTitle = isCreateNewListModal ? createNewList : title;

        const newSkuToAdd = {
            source: 'productPage',
            productId: skuLoveData.productId,
            skuId: skuLoveData.skuId
        };

        return (
            <>
                <Modal
                    isOpen={isOpen}
                    width={0}
                    isHidden={isHidden || isCreateNewListModal}
                    isDrawer={true}
                    hasBodyScroll={true}
                    onDismiss={this.handleClick}
                >
                    <Modal.Header>
                        <Modal.Title>{modalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body
                        lineHeight='tight'
                        paddingBottom={4}
                        css={styles.mainListWrapper}
                    >
                        {myLists?.allLoves &&
                            myLists.allLoves
                                .filter(list => !list.isCreateList)
                                .map(list => {
                                    const listId = list.shoppingListId;
                                    const listName = list.shoppingListName;
                                    const showImage = (imageDisplayFlag[listId] && !hasClickedCtaOnceById[listId]) || shouldDisplayImageById[listId];
                                    const count = itemsCount[list.shoppingListId] ?? list.shoppingListItemsCount;

                                    return (
                                        <Box
                                            key={listId}
                                            css={styles.myListItem}
                                        >
                                            <Grid
                                                columns={showImage ? 'auto 1fr 86px' : 'auto 86px'}
                                                alignItems='flex-start'
                                            >
                                                {showImage && <ProductImage {...skuLoveListImageData} />}

                                                <Box
                                                    fontSize='m'
                                                    css={{ alignSelf: 'center' }}
                                                >
                                                    <Text
                                                        css={{ whiteSpace: 'break-spaces' }}
                                                        is='h3'
                                                        display='block'
                                                        numberOfLines={2}
                                                        children={list.shoppingListName}
                                                    />
                                                    <Link
                                                        color='link'
                                                        children={`${count} ${count === 1 ? localization.item : localization.items}`}
                                                        onClick={e => this.handleListClick(e, list.shoppingListId)}
                                                    />
                                                </Box>

                                                {this.renderCTA(skuLoveData, listId, listName)}
                                            </Grid>

                                            {listErrorsById[listId] && (
                                                <Box marginTop={4}>
                                                    <Text color='red'>{listErrorsById[listId]}</Text>
                                                </Box>
                                            )}
                                        </Box>
                                    );
                                })}
                    </Modal.Body>
                    <Modal.Footer
                        hasBorder={true}
                        paddingX={[3, 3]}
                    >
                        <Flex css={styles.ctaContainer}>
                            <Button
                                variant='secondary'
                                css={styles.secondaryBtn}
                                onClick={this.toogleCreateNewListModal}
                            >
                                {createNewList}
                            </Button>
                            <Button
                                variant='primary'
                                css={styles.primaryBtn}
                                onClick={this.handleClick}
                            >
                                {done}
                            </Button>
                        </Flex>
                    </Modal.Footer>
                </Modal>

                {isCreateNewListModal && (
                    <CreateNewListModal
                        onDismiss={this.toogleCreateNewListModal}
                        isListLimitReached={isListLimitReached}
                        showCreateListModal={this.props.showCreateListModal}
                        showMyListsModal={showMyListsModal}
                        newSkuToAdd={newSkuToAdd}
                        handleNewListCreated={this.handleNewListCreated}
                        handleLoveError={(error, shoppingListId) => {
                            this.handleNewListCreated();
                            this.toogleCreateNewListModal();
                            this.handleLoveError(error, shoppingListId);
                        }}
                    />
                )}
            </>
        );
    }
}

const styles = {
    mainListWrapper: {
        [mediaQueries.md]: {
            maxHeight: '55vmax'
        },
        '> div': {
            paddingBottom: space[4],
            paddingTop: space[4],
            borderBottom: '1px solid #eeeeee'
        },
        '> :last-child': {
            borderBottom: 'none',
            paddingBottom: 0
        }
    },
    myListItem: {
        ':first-child': {
            paddingTop: 0
        }
    },
    ctaContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 16,
        marginTop: 2
    },
    primaryBtn: {
        width: '100%'
    },
    secondaryBtn: {
        width: '100%'
    }
};

MyListsModal.propTypes = {
    isOpen: PropTypes.bool,
    myLists: PropTypes.object,
    showMyListsModal: PropTypes.func,
    getAllLists: PropTypes.func.isRequired,
    skuLoveData: PropTypes.object,
    skuLoveListImageData: PropTypes.object,
    isListLimitReached: PropTypes.bool,
    imageDisplayFlag: PropTypes.object
};

export default wrapComponent(MyListsModal, 'MyListsModal', true);
